module.exports = __webpack_public_path__ + "img/certifier.045f5730.png";